import React from 'react';
import moment from 'moment';
import { Box } from 'bloomer/lib/elements/Box';
import { Content } from 'bloomer/lib/elements/Content';
import { Title } from 'bloomer/lib/elements/Title';
import { printMinutesAndSeconds } from '../util/helperFunctions';
import Bold from '../elements/Bold';

const SingleEnrichmentDisplay = ({ context }: { context?: Enrichment }) => {
  if (!context) {
    return <p>Context not found.</p>;
  }

  const {
    walkerName,
    walkerType,
    aNumber,
    animalName,
    animalType,
    colorCode,
    enrichmentType,
    longStayStartTracking,
    minutesOfEnrichment,
    trainingPlan,
    timeTakenOut,
    timeReturned,
  } = context;
  return (
    <Box>
      <Content>
        <p>
          <Bold>Note:</Bold> This information reflects the status of this animal at the time of the enrichment session,
          not as it is now.
        </p>
        <Title tag="h5" isSize={4}>
          <Bold>Enrichment Information:</Bold>
        </Title>
        <p className="is-size-5">
          <Bold>Enricher:</Bold> {walkerName}
        </p>
        <p className="is-size-5">
          <Bold>Enricher Type:</Bold> {walkerType}
        </p>
        <p className="is-size-5">
          <Bold>Enrichment Type:</Bold> {enrichmentType}
        </p>
        <p className="is-size-5">
          <Bold>Length of Enrichment Session:</Bold> {printMinutesAndSeconds(minutesOfEnrichment)} <br />(
          {moment(timeTakenOut).format('h:mma YYYY/MM/DD')} - {moment(timeReturned).format('h:mma YYYY/MM/DD')})
        </p>
        <p className="is-size-5" />
        <Title tag="h5" isSize={3}>
          <Bold>Animal Information: </Bold>
        </Title>
        <p className="is-size-5">
          <Bold>Animal: </Bold> A#{aNumber} "{animalName}"
        </p>
        <p className="is-size-5">
          <Bold>Animal Type: </Bold> {animalType}
        </p>
        <p className="is-size-5">
          <Bold>Colour Code: </Bold> {colorCode}
        </p>
        <p className="is-size-5">
          <Bold>Long Stay: </Bold> {longStayStartTracking ? 'yes' : 'no'}
        </p>
        <p className="is-size-5">
          <Bold>Training Plan:</Bold> {trainingPlan}
        </p>
      </Content>
    </Box>
  );
};

export default SingleEnrichmentDisplay;
